import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4ca8738c&"
import script from "../node_modules/ckeditor4-vue/dist/ckeditor.js?vue&type=script&lang=js&"
export * from "../node_modules/ckeditor4-vue/dist/ckeditor.js?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
